(ns renolit-roofing-service.view.service.delete-confirmation-popup
  (:require [re-frame.core :as rf]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.tooltip :as tooltip]
            [renolit-roofing-service.tooltip.generic-popup :as tooltip.generic-popup]))

(def ^:const view-context ::delete-review)

(def ^:const popup-id tooltip.generic-popup/default-popup-id)

(defn- main
  [{:keys [on-submit item-title]}]
  [:<>
   [tooltip.generic-popup/generic-popup-header
    {:title-transl-kw (t [:page.service.add/delete-confirmation-title])
     :popup-id popup-id}]
   [:div.general-zone-revision-popup
    [:div.general-zone-revision-popup__wp
     [:div item-title]]]
   [tooltip.generic-popup/generic-popup-footer
    {:popup-id popup-id
     :on-cancel {:evt [::tooltip/destroy-by-id {:id popup-id}]}
     :on-accept {:label-transl-kw :common/okay
                 :fn (fn []
                       (rf/dispatch [::form.error/clear-errors :context])
                       (on-submit)
                       (rf/dispatch [::close]))}}]])

(rf/reg-event-fx
 ::close
 (fn [_]
   {:fx [[:dispatch [::form.error/clear-errors view-context]]
         [:dispatch [::tooltip/destroy-by-id {:id popup-id}]]]}))

(rf/reg-event-fx
 ::open
 (fn [_ [_ opts]]
   {:fx [[:dispatch [::tooltip/register {:id popup-id
                                         :on-destroy-evt [::close]
                                         :component main
                                         :argv [opts]
                                         :class ["generic-popup-standard"]}]]]}))
